import { GetQuoteResponse } from "src/model/api/quote/get-quote-response.model";
import { ConnectionTypeId, InstallationCablingResponse } from "src/model/api/v2/data-contracts";

export type PinoutData = InstallationCablingResponse & {
  network_devices: any[];
};

export function getNetworkDevices(quote: GetQuoteResponse) {
  if (
      typeof quote === "object" &&
      Array.isArray(quote["network-planner"])
  ) {
    let result = quote["network-planner"];

    result = result.filter((dev) => {
      if (
          dev.originalImageHeight === null ||
          dev.originalImageWidth === null
      ) {
        console.debug(
            "filtered network device since it doesnt have image size set"
        );
        return false;
      }
      if (!Array.isArray(dev.inputs)) {
        console.debug(
            "filtered network device since it doesnt have inputs array"
        );
        return false;
      }

      for (let i = 0; i < dev.inputs.length; i++) {
        const input = dev.inputs[i];
        if (input.xPosition === null || input.yPosition === null) {
          console.debug(
              "filtered network device since element in input array has null position"
          );
          return false;
        }
      }

      return true;
    });

    result.forEach((dev) =>
        dev.connections.forEach((conn: any) => {
          conn.sourceTypeId = ConnectionTypeId.PORT;
          conn.targetTypeId = ConnectionTypeId.PLAIN_TEXT;
        })
    );
    return result;
  } else {
    return [];
  }
}

export function convertToPinoutData(
    installationCabling: InstallationCablingResponse,
    networkDevices: any[],
    mounted: boolean,
): PinoutData | false | undefined {
  if (!mounted) {
    return;
  }

  // PRE-FILTER: remove TreeLines from old bus array (if prod)
  const buses = installationCabling.buses.filter((bus) => bus.id.indexOf("TreeLine") !== 0);

  const noPinout =
      buses.length === 0 &&
      installationCabling.devices.length === 0 &&
      installationCabling.cables.length === 0;

  const noTree = installationCabling.tree_lines.every((treeBus) => treeBus.extensions.length === 0);

  const noNetwork = networkDevices.length === 0;

  if (noTree && noPinout && noNetwork) {
    return false;
  }

  return {
    ...installationCabling,
    buses,
    network_devices: networkDevices,
  };
}
